export function isValidUrl(url: string) {
  const containsWhitespacesOrLineBreaks = /\s/.test(url)
  if (containsWhitespacesOrLineBreaks) {
    return false
  }
  try {
    new URL(url)
    return true
  } catch (err) {
    return false
  }
}
